export const FontFamily = {
    DIGITAL_7: 'Digital-7',
} as const

export const TimeColor = {
    TIME_RUNNING_COLOR: '#333333',
    TIME_PAUSED_COLOR: '#999999',
    TIME_UP_COLOR: 'red',
} as const

export const StateLabel = {
    NOT_STARTED: 'NOT STARTED',
    ONGOING: 'ONGOING',
    PAUSED: 'PAUSED',
    ENDED: 'ENDED',
} as const

export const StateThemeColor = {
    NOT_STARTED: 'whitesmoke',
    ONGOING: '#3dccc7',
    PAUSED: '#ff9f1c',
    ENDED: 'red',
} as const

export const LocalStorageKey = {
    SETTINGS: 'SETTINGS',
    GAME_SAVE: 'GAME_SAVE',
} as const
